// Toggles an item's expansion state in an array of expanded item IDs.
import { RefObject } from 'react';

const toggleItemExpansion = <T,>(id: T, prevExpanded: T[]): T[] => {
  const isCurrentlyExpanded: boolean = prevExpanded.includes(id);

  // If already expanded, collapse it by removing from the array.
  if (isCurrentlyExpanded) {
    return prevExpanded.filter((itemId: T): boolean => itemId !== id);
  }

  // If currently collapsed, expand it by adding to the array.
  return [...prevExpanded, id];
};

// Calculate character limit based on container width - https://developer.mozilla.org/en-US/docs/Web/API/Element/getBoundingClientRect
const calculateTableCharLimit = (
  tableRef: RefObject<HTMLDivElement>
): number => {
  if (tableRef.current) {
    // Get the description cell width. approximated as 40% of the table width.
    const tableWidth: number = tableRef.current.getBoundingClientRect().width;
    const descriptionColWidth: number = tableWidth * 0.4;

    // Approximate character count based on average character width. (assuming there is an average of 8px per character in standard font).
    const avgCharWidth: number = 8;
    const approxCharLimit: number = Math.floor(
      descriptionColWidth / avgCharWidth
    );

    // Set a reasonable minimum limit.
    return Math.max(approxCharLimit, 40);
  }
};

export { toggleItemExpansion, calculateTableCharLimit };

// Feel free to add more utility functions here that can be shared + reused across different components/pages.
